import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const NurseNav = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [value, setValue] = useState("/nurse");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = ["/nurse", "/nurse/my-patients", "/nurse/vital-signs", "/nurse/nursing-notes", "/nurse/medications", "/nurse/shift-handover"];

    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/nurse");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" }, // Ensures tabs have consistent width
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/nurse" ? theme.palette.primary.main : "white",
                color: value === "/nurse" ? "white" : "black",
              }}
              label={t("nurse.dashboard")}
              value="/nurse"
              component={NavLink}
              to="/nurse"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/nurse/my-patients" ? theme.palette.primary.main : "white",
                color: value === "/nurse/my-patients" ? "white" : "black",
              }}
              label={t("nurse.myPatients", "My Patients")}
              value="/nurse/my-patients"
              component={NavLink}
              to="/nurse/my-patients"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/nurse/vital-signs" ? theme.palette.primary.main : "white",
                color: value === "/nurse/vital-signs" ? "white" : "black",
              }}
              label={t("nurse.vitalSigns", "Vital Signs")}
              value="/nurse/vital-signs"
              component={NavLink}
              to="/nurse/vital-signs"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/nurse/nursing-notes" ? theme.palette.primary.main : "white",
                color: value === "/nurse/nursing-notes" ? "white" : "black",
              }}
              label={t("nurse.nursingNotes", "Nursing Notes")}
              value="/nurse/nursing-notes"
              component={NavLink}
              to="/nurse/nursing-notes"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/nurse/medications" ? theme.palette.primary.main : "white",
                color: value === "/nurse/medications" ? "white" : "black",
              }}
              label={t("nurse.medications", "Medications")}
              value="/nurse/medications"
              component={NavLink}
              to="/nurse/medications"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/nurse/shift-handover" ? theme.palette.primary.main : "white",
                color: value === "/nurse/shift-handover" ? "white" : "black",
              }}
              label={t("nurse.shiftHandover", "Shift Handover")}
              value="/nurse/shift-handover"
              component={NavLink}
              to="/nurse/shift-handover"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default NurseNav;
